$(document).ready(function () {
    $('.slick-responsive-offscreen').slick({
        mobileFirst: true,
        dots: false,
        infinite: false,
        slidesToShow: 1.3,
        slidesToScroll: 1,
        arrows: false,
        responsive: [
            {
                breakpoint: 1181,
                settings: "unslick"
            }
        ]
    });
});